export const products = [
  {
    id: 1,
    name: '数字化全流程宣教平台',
    category: '应用端口',
    description: '患者扫码，接受宣教，填写问卷',
    features: ['宣教视频目录', '多节点问卷调查', '数据结果动态同步'],
    specs: {
      '个性化宣教内容管理': '平台建立了完善的数字化宣教内容管理体系。医疗机构可以根据自身特点，定制符合科室特色、疾病特点的宣教内容库。内容形式包括视频、图文、动画等多种形式，满足不同患者群体的学习偏好。宣教内容按照疾病类型、治疗阶段、患者特征等进行智能分类和标签化管理。当患者入院时，系统会根据其诊断信息、治疗方案等自动匹配相应的宣教内容，形成个性化的宣教计划。这种“一人一策”的精准宣教，大大提高了宣教的针对性和有效性。',
      '诊疗关键节点问卷调查': '平台集成了智能问卷调查系统，支持在患者诊疗的不同阶段进行满意度调查、知识掌握度测试、康复进展评估等。问卷设计采用模块化方式，医疗机构可以根据需要灵活配置问卷内容和发放时机。',
      '宣教与问卷结果实时反馈': '问卷调查结果实时同步到平台数据库，医护人员和管理者可以随时查看患者的反馈情况。系统还提供数据分析功能，能够自动生成问卷结果统计报告，识别共性问题，为质量改进提供数据支持。问卷调查与宣教内容实现了智能联动。当系统检测到患者在某个知识点上掌握不足时，会自动推送相关的补充宣教内容。这种“教查相辅”的模式，确保了宣教效果的闭环管理。',
    },
    image: require('@/assets/images/product-1.png')
  },
  {
    id: 2,
    name: '医患即时通讯系统',
    category: '应用端口',
    description: '患者登录康福宝小程序 医护注册登录康福宝医讯台小程序',
    features: ['健康知识传播与教育', '医患即时通讯', '医学问答社区', '智能随访管理', '创作者中心'],
    specs: {
      '健康知识传播与教育': '系统根据患者的疾病特征、治疗阶段等信息，进行智能匹配和精准推送健康知识。',
      '医患即时通讯': '平台建立了独立、安全的医患即时通讯系统。医护人员和患者分别通过专用小程序进行注册和认证，确保沟通双方身份的真实性和可信度。通讯系统支持一对一沟通和群组沟通两种模式。对于需要多科室协作的复杂病例，可以建立跨科室沟通群组，方便信息共享和协同工作。',
      '医学问答社区': '平台构建了专业的医学问答社区，患者可以在这里提出健康相关问题，由专业医护人员进行解答。问答社区按照疾病科室进行分类管理，方便患者快速找到相关信息。',
      '智能随访管理': '基于患者诊疗数据和沟通历史，平台提供智能随访管理功能。医生可以根据患者的疾病类型、治疗阶段、康复情况等，生成个性化的随访计划。随访内容包括康复指导、用药提醒、复诊安排、生活方式建议等。',
      '创作者中心': '平台建立了医护创作激励体系，鼓励医护人员创作和分享健康科普内容。医护人员可以通过平台专用小程序，方便地制作和发布短视频、图文等科普内容。平台提供内容制作工具和模板，降低创作门槛。',
    },
    image: require('@/assets/images/product-2.png')
  },
  {
    id: 3,
    name: '医患沟通管理与评价体系',
    category: '智能硬件',
    description: '康福宝宣教机助推医患沟通溯源信息化建设',
    features: ['共性告知', '个性告知', '云端见证', '三维器官展示', '谈话智能体评价'],
    specs: {
      '标准化共性告知': '针对常见疾病和常规治疗，平台提供标准化的共性告知内容。这些内容由医学专家团队精心制作，确保信息的准确性、规范性和易懂性。共性告知内容涵盖疾病基础知识、常规检查说明、标准治疗方案介绍、常见风险告知等内容。',
      '个性告知': '平台提供完整的医患沟通记录功能，支持语音、视频等多种沟通形式的记录与存储。在关键医疗环节，如术前告知、特殊检查说明、治疗方案讨论等，平台支持沟通过程的全程录音录像。这些音视频资料采用云端和本地双存储模式，确保数据的安全性和可追溯性。',
      '云端见证': '第三方见证人员通过远程服务实时跟踪，患者家属即使不在现场，也可以通过微信扫码远程参与沟通过程，确保所有相关方的知情权和参与权。',
      '三维器官演示': '平台集成了先进的三维医学可视化技术，内置全结构人体器官模型库。医护人员在向患者解释病情和治疗方案时，可以使用三维模型进行直观演示。\n\n' +
          '三维模型支持多种交互操作：\n' +
          '（1）旋转查看：可以从不同角度观察器官结构。\n' +
          '（2）缩放操作：可以放大查看细节或缩小查看整体。\n' +
          '（3）分层显示：可以隐藏或显示不同组织层次。\n' +
          '（4）动态演示：可以展示手术过程或疾病发展过程。\n',
      '谈话智能体评价': '基于人工智能技术，平台开发了医患沟通质量智能评价系统。该系统采用自然语言处理和机器学习算法，能够对医患沟通过程进行多维度分析评价。\n\n' +
          '评价维度包括但不限于：\n' +
          '（1）疾病介绍完整性：是否全面介绍了疾病的基本知识、发病机制、临床表现等。\n' +
          '（2）治疗方案说明充分性：是否详细说明了治疗方案的原理、步骤、预期效果等。\n' +
          '（3）风险告知全面性：是否充分告知了治疗可能存在的风险、并发症等。\n' +
          '（4）替代方案介绍：是否提供了其他可行的治疗方案供患者选择。\n' +
          '（5）沟通态度与技巧：医护人员的沟通方式是否耐心、细致、有同理心。\n',
    },
    image: require('@/assets/images/product-3.png')
  },
  {
    id: 4,
    name: '院长驾驶舱系统',
    category: '应用端口',
    description: '提供多类型数据分析图表，为决策层提供不同区域、不同视角下的数据洞察力',
    features: ['动态可视化面板', '自定义报表生成', '患者满意度趋势', '患者参与式不良事件反馈系统'],
    specs: {
      '医疗质量监控': '实时监测关键质量指标，识别潜在风险。',
      '服务流程优化': '分析服务瓶颈，提出改进建议。',
      '资源配置优化': '根据患者需求变化，优化医疗资源分配。',
      '发展趋势预测': '基于历史数据，预测医疗服务需求变化。',
    },
    image: require('@/assets/images/product-4.png')
  },
]

export const news = [
  {
    id: 1,
    title: '康福宝平台入院“第十三届全国医院管理工具大会暨第五届医疗质量与安全管理论坛”优秀案例',
    category: '企业动态',
    date: '2026-04-16',
    excerpt: '2025年10月30日，由国家卫生健康委医疗管理服务指导中心指导，清华大学医院管理研究院主办的“第十三届全国医院管理工具大会暨第五届医疗质量与安全管理论坛”中，康福宝信息化沟通平台作为案例内容并获得优秀案例。',
    content: '2025年10月30日，由国家卫生健康委医疗管理服务指导中心指导，清华大学医院管理研究院主办的“第十三届全国医院管理工具大会暨第五届医疗质量与安全管理论坛”中，康福宝信息化沟通平台作为案例内容并获得优秀案例。\n\n' +
        '康福宝项目自成立以来，始终以提升医疗服务质量和促进医患和谐为核心目标，通过信息化手段和综合风险管理服务，提升患者的就医体验，减轻医疗机构的风险负担，并优化医疗服务流程。特别是在信息化管理中，提供了一项切实可行又易于操作的数据平台服务，大大提高了在医疗告知义务履行中的效果和效率，降低了因医疗告知义务履行缺陷带来的医疗纠纷风险。解决了在解决医疗纠纷中常常因证据不足而带来的困扰，同时也可以作为科室在沟通告知中进行内部学习培训的教学视频，保证规范化诊疗，提高科室整体专业素养。',
    image: require('@/assets/images/news-1.png')
  },
  {
    id: 2,
    title: '康福宝医患沟通平台— —国家卫健委患者安全管理工具优秀实例，助力医疗安全高质量发展',
    category: '企业动态',
    date: '2026-04-06',
    excerpt: '国家卫健委医院管理研究所主办的“第三届中国医疗质量大会”在杭州成功举行。此次盛会吸引了全国医疗领域的专家学者及领导齐聚一堂，共同交流和学习医疗质量管理的经验，旨在促进医疗质量的提高和患者安全管理的完善。',
    content: '由国家卫健委医院管理研究所主办的“第三届中国医疗质量大会”在杭州成功举行。此次盛会吸引了全国医疗领域的专家学者及领导齐聚一堂，共同交流和学习医疗质量管理的经验，旨在促进医疗质量的提高和患者安全管理的完善。\n\n' +
        '经过三个月的精心筛选和多轮严格评审，泰安市康福宝医疗科技有限公司自主研发的“康福宝”医患沟通平台项目，经由泰安市中心医院实践运营近5年后，成功入选患者安全工具优秀实例，并受邀分享案例内容及项目经验。\n\n' +
        '康福宝医患沟通平台自推出以来，一直积极回应国家提升医疗质量的政策号召，致力于运用科技手段改善医患之间的沟通，从而增强患者的就医体验。该平台助力于在医生与患者之间构建更为紧密的联系，并提高医疗服务的效率和透明度。\n\n' +
        '项目内容：\n' +
        '1.核心服务：“康福宝”医患沟通平台的核心功能包括医患教育培训、第三方云端见证服务以及医疗风险分担服务等多个方面。这些功能的综合运用显著提升了医患沟通的效率和质量，积极应对医疗领域所面临的挑战与机遇。\n\n' +
        '2.数据反馈：康福宝利用先进的大数据分析技术，能够依据风险分担服务和随访数据，整理出医疗质量反馈报告，并定期向医疗机构的职能部门和临床科室提供，为医疗机构提供精准的服务改进依据，从而推动医疗质量的持续提升。\n\n' +
        '3.多方合作：目前，康福宝已与全国三十多家医疗机构建立合作，覆盖多个城市，致力于扩大服务范围，使更多患者能够享受到便捷和高效的医疗服务。\n\n' +
        '展望未来，康福宝医疗科技有限公司将继续深入研究医疗过程中各个环节医患的实际需求，探索更多创新解决方案，力争在医疗质量和患者安全领域取得更大突破。我们将始终秉持“以患者为中心”的理念，不断优化和升级平台功能，为推动中国医疗事业的发展贡献力量。\n\n',
    image: require('@/assets/images/news-2.jpg')
  },
  {
    id: 3,
    title: '康福宝入选“改善就医感受，提升患者体验”创新实践案例',
    category: '企业动态',
    date: '2026-03-30',
    excerpt: '泰安市中心医院联合康福宝，以“康福宝”医患沟通平台服务内容为核心，共同参加了由国家卫生健康委医院管理研究所2024年3月份组织开展“改善就医感受，提升患者体验”创新实践案例征集活动和4月组织开展的患者安全工具实例征集活动。',
    content: '泰安市中心医院联合康福宝，以“康福宝”医患沟通平台服务内容为核心，共同参加了由国家卫生健康委医院管理研究所2024年3月份组织开展“改善就医感受，提升患者体验”创新实践案例征集活动和4月组织开展的患者安全工具实例征集活动。经过3个月的筛选及多轮严肃评审，最终分别入围“优秀案例”和“优秀实例”，并受邀参加2024年第三届“中国医疗质量大会”，领取荣誉证书并分享交流实例内容。\n\n' +
        '随着“互联网+医疗健康”政策的持续推进，医疗领域经历了数字化转型的显著发展，为增进医患沟通及优化患者体验创造了新的机遇。2020年，泰安市康福宝医疗科技有限公司适时推出了“康福宝”医患沟通平台。该平台融合了软硬件资源，实现线上线下的并行服务，整合尖端的信息技术，为医生与患者之间构建了一座高效且便捷的沟通桥梁，显著提升了医疗服务的质量与效率。\n\n ' +
        '“康福宝”医患沟通平台的核心功能涵盖了医患教培服务、第三方云端见证服务、医疗风险分担服务等多个方面。这些措施共同提升医患沟通的效率和质量，积极应对医疗领域面临的挑战和机遇。\n\n  ' +
        '同时，“康福宝”平台积极响应国家号召，与多地市的三十余家医疗机构建立战略合作关系，推动医疗资源下沉，实现优质医疗服务的共享与均衡。通过资源共享和合作机制，完善平台教培网络建设，节省社会资源，并提升合作医疗机构的内容制作水平，实现了合作医疗机构患者宣教及医护培训内容的“共建、共创、共享”。\n\n ' +
        '近年来，我司积极与泰安市中心医院开展深入合作，共同探索数字化医疗服务的更多可能性。通过四年不断磨合，成功将“康福宝”医患沟通平台应用于日常医疗服务中，取得了显著的成效。“康福宝”医患沟通平台在实际应用中不断优化和完善，为信息时代的医疗服务创新升级树立了新的标杆。\n\n ' +
        '未来，“康福宝”医患沟通平台将继续秉承“以人为本，科技赋能”的理念，不断探索医疗服务的数字化转型之路，致力于构建一个更加高效、便捷、安全、温馨的医疗服务生态系统，为人民的健康福祉贡献力量。\n\n '
    ,
    image: require('@/assets/images/news-3.jpg')
  }
]

export const defaultSettings = {
  logo: require('@/assets/images/logo.png'),
  companyName: '康福宝',
  phone: '13375386313（赵经理）',
  phonePosition: '',
  email: 'kangfubao666@163.com',
  address: '山东省泰安市奥莱新天第',
  homeHeroTitle: '医患沟通信息化建设 康福宝医疗科技',
  homeHeroSubtitle: '以患者宣教为核心，衍生出多节点、多形式、多模块的医患沟通解决方案，依托多端互联技术协同线上线下多轨联动机制，构建综合性医患沟通平台。',
  homeHeroImage: require('@/assets/images/homeHeroImage.png'),
  homeHeroBadge: '让医院回归医疗本质',
  homeIntroTitle: '信息化全流程沟通体系',
  homeIntroContent: '康福宝医患沟通平台通过硬件+软件+内容的交互式体系建设，实现宣教进度实时追踪、风险告知精准触达、疑问解答及时响应、满意度动态反馈及患者参与式不良事件上报等功能，为医患双方构建了一套聚焦诊疗关键节点的多链路全时段沟通机制。',
  homeIntroImage:require('@/assets/images/homeIntroImage.jpeg'),
  aboutTitle: '关于康福宝',
  aboutSubtitle: '以科技之名，赋能健康生活，守护亿万家庭。',
  aboutContent: '康福宝医患沟通平台代表了医疗行业数字化转型的重要方向。通过技术创新和模式创新，平台系统性地解决了医患沟通中的痛点问题，推动医疗服务从"以疾病为中心"向"以人为中心"转变，从单次诊疗向全程管理转变，从经验决策向数据决策转变。',
  aboutImage: require('@/assets/images/aboutImage.png'),
  contactTitle: '联系我们',
  contactSubtitle: '我们期待倾听您的声音，为您提供最专业的健康咨询与支持。',
  navItems: [
    { name: '首页', href: '/' },
    { name: '企业介绍', href: '/about' },
    { name: '产品展示', href: '/products' },
    { name: '新闻资讯', href: '/news' },
    { name: '联系我们', href: '/contact' }
  ],
  productCategories: ['全部', '应用端口', '知识产权', '其他信息技术服务', '智能硬件'],
  newsCategories: ['企业动态', '行业资讯', '社会责任'],
  videos: [
    {
      id: 1,
      title: '三维立体器官全景演示',
      description: '平台集成三维医学可视化技术与全结构人体器官模型库，支持医护人员通过三维模型直观为患者讲解病情及治疗方案。',
      url: require('@/assets/videos/260414-1280×720.mp4'),
      thumbnail: require('@/assets/images/thumbnail.png')
    }
  ],
  features: [
    { title: '品质认证', desc: '通过信息安全管理/技术服务体系认证', icon: 'ShieldCheck' },
    { title: '人工智能', desc: 'AI 赋能沟通', icon: 'Zap' },
    { title: '贴心服务', desc: '7×24 小时在线支持', icon: 'CheckCircle2' }
  ],
  team: [
    { name: '张博士', position: '首席技术官', bio: '哈佛医学院博士，专注于医疗AI研究10年', image: '' },
    { name: '李教授', position: '研发总监', bio: '清华大学教授，医疗设备研发专家', image: '' },
    { name: '王工程师', position: '产品经理', bio: '前苹果公司产品经理，专注用户体验设计', image: '' }
  ],
  teamSection: { title: '专业团队', description: '由百余位医学博士与工程师组成的研发核心。' },
  laboratorySection: { title: '学术交流', description: '拥有多项国家级医患关系研究课题案例。' },
  aboutLinkText: '深入了解我们的故事',
  ctaSection: {
    title: '准备好提升您的医患沟通效率了吗？',
    description: '立即联系我们的专职顾问，为您定制专属的医患沟通信息化建设方案。',
    buttonText: '联系我们',
    hotlineText: '400-123-4567'
  },
  laboratory: {
    title: '前沿实验室',
    subtitle: '引领医疗科技前沿',
    description: '康福宝前沿实验室拥有国际先进的医疗设备和研发团队，致力于开发创新的健康监测技术和产品。',
    image: require('@/assets/images/thumbnail.png'),
    equipment: [
      { name: '高精度医疗传感器', description: '实时监测健康数据，精度达到医疗级标准' },
      { name: 'AI 诊断系统', description: '基于深度学习的智能诊断技术' },
      { name: '生物信息分析平台', description: '快速处理和分析大量健康数据' }
    ]
  },
  productsSection: {
    title: '核心产品',
    subtitle: '让医患沟通更规范、更有温度',
    description: '打造"四端协同+AI赋能"模式，解决患教内容问题、投放路径问题、效果量化问题、沟通效率问题'
  },
  newsSection: { title: '新闻资讯', subtitle: '了解康福宝的最新动态' },
  videoSection: { title: '视频展示', subtitle: '了解康福宝的产品与服务', description: '通过视频了解康福宝的创新产品、专业服务和成功案例。' },
  footerDescription: '康福宝致力于通过先进的信息技术和创新的宣教形式，为医疗机构提供全方位的医患沟通管理方案。以人为本，创新驱动。',
  aboutMission: [
    { title: '企业使命', desc: '让每一位患者都能享受到专业、便捷、高效的智慧医疗服务。', icon: 'Target' },
    { title: '企业愿景', desc: '让医疗更有温度，让医患更加和谐。', icon: 'Eye' },
    { title: '核心价值观', desc: '客户第一、持续创新、协作共赢、诚信负责。', icon: 'Award' }
  ],
  aboutStoryTitle: '十余载深耕\n只为那一刻的安心守护',
  aboutTimeline: {
    title: '发展历程',
    subtitle: '砥砺前行，铸就辉煌',
    milestones: [
      { year: '2017', title: '第三方见证', desc: '2017年成立泰安市宏鑫医疗科技有限公司，开始为医院医患沟通提供第三方见证服务' },
      { year: '2018', title: '缔造新模式', desc: '通过第三方见证服务为患者引荐手术意外保险产品，引领华东地区手术意外险产品销售模式' },
      { year: '2019', title: '模式转折', desc: '2019年末随着进入疫情防控常态化，为突破时空局限，优化见证流程，筹建线上医患沟通平台' },
      { year: '2022', title: '康福宝医患沟通平台', desc: '康福宝医患沟通平台完成开发并投入运营，满足更多更深层次的医患沟通需求' },
      { year: '2024', title: '运营成果', desc: '入选国家卫健委医院管理研究所"改善就医感受，提升患者体验""创新实践案例和第三届中国医疗质量大会"患者安全工具优秀实例，服务医院三十余家，累计服务患者三十余万人次。' }
    ]
  },
  productsPage: {
    title: '产品中心',
    subtitle: '创新医疗科技，为每一位用户的健康生活提供精密保障。',
    image: require('@/assets/images/三张背景图-产品1.jpg')
  },
  newsPage: {
    title: '新闻资讯',
    subtitle: '了解康福宝的最新动态和行业资讯。',
    image: require('@/assets/images/news-image1.png')
  },
  contactPage: {
    title: '联系我们',
    subtitle: '我们期待倾听您的声音，为您提供最专业的健康咨询与支持。',
    image: require('@/assets/images/news-image1.png')
  }
}
